import { render, staticRenderFns } from "./BenefitsTile.vue?vue&type=template&id=72110b6e&scoped=true"
import script from "./BenefitsTile.vue?vue&type=script&lang=js"
export * from "./BenefitsTile.vue?vue&type=script&lang=js"
import style0 from "./BenefitsTile.vue?vue&type=style&index=0&id=72110b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72110b6e",
  null
  
)

export default component.exports